/**
 * Returns the initials of a name.
 * @param name - The name to get the initials from.
 * @returns The initials of the name.
 */
export const getNameInitials = (name = '') => {
  name = name ? name.trim() : '';
  const parts = name.split(' ');
  let initials = '';

  if (name.length === 0) {
    initials = 'AU';
  } else {
    parts.length > 1
      ? (initials = parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase())
      : (initials = parts[0][0].toUpperCase());
  }
  return initials;
};

/**
 * Converts a string to title case.
 * @param string - The string to convert.
 * @returns The title case version of the string.
 */
export const titleCase = (string = '') => {
  const newString = string.toLowerCase().split(' ');
  if (newString.length) {
    return newString
      .map(function (word) {
        if (!word) return '';
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(' ');
  }
  return '';
};

/**
 * Removes underscores from a string and capitalizes the first letter of each word.
 * @param str - The string to process.
 * @returns The processed string.
 */
export const removeUnderscoresAndCapitalize = (str: string | number): string =>
  removeUnderscores(titleCase(String(str)));

/**
 * Removes underscores from a string
 * @param str - The string to process.
 * @returns The processed string.
 */
export const removeUnderscores = (str: string | number): string => String(str).replaceAll('_', ' ');
